import { render, staticRenderFns } from "./ShiftForm.vue?vue&type=template&id=2874e53a"
import script from "./ShiftForm.vue?vue&type=script&lang=js"
export * from "./ShiftForm.vue?vue&type=script&lang=js"
import style0 from "./ShiftForm.vue?vue&type=style&index=0&id=2874e53a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports